import React from 'react'
import { Customer } from '../models/shared/Customer'
import { SearchResultCustomer } from '../models/shared/SearchResults'

interface Props {
    customer: Customer | SearchResultCustomer | undefined | null
    className?: string
}

export default function CustomerName(props: Props) {
    if (!props.customer) {
        return <></>
    }

    const isPerson = props.customer.type === 'person';
    const name = isPerson ? `${props.customer.name} ${props.customer.lastName}` : props.customer.name;

    return (
        <div className={`d-flex gap-2 ${props.className}`}>
            <i className={`bi ${isPerson ? 'bi-person-fill' : 'bi-building-fill'}`} />
            <div>{name}</div>
        </div>
    )
}
